<div>
  <section appScrollManager>
    <br />
    <br />
    <br />
    <h1 class="Join-title">Where to shop!</h1>
    <br />
    <br />
    <div
      fxLayout="row wrap"
      fxLayoutAlign="stretch"
      *ngFor="let items of stores"
    >
      <div
        fxFlex.gt-sm="10"
        fxFlex.lt-md="20"
        fxFlex.lt-sm="33.33"
        class="partner-tile-container"
        *ngFor="let item of items.items"
      >
        <mat-card
          (click)="click(item.placementId!, item.websiteUrl!)"
          class="mat-elevation-z4 partner-tile"
          [style.background]="
            'linear-gradient(to right,rgba(255,255,255,0.7),rgba(255,255,255,0.7)),url(' +
            item.coverUrl +
            ')'
          "
        >
          <img class="img-logo" mat-card-image [lazyLoad]="item.logoUrl!" />
        </mat-card>
      </div>
      <div
        fxFlex.gt-sm="10"
        fxFlex.lt-md="20"
        fxFlex.lt-sm="33.33"
        class="partner-tile-container"
      >
        <mat-card
          [routerLink]="['/where-to-shop']"
          class="mat-elevation-z4 partner-tile"
          [style.background]="'#E25E63'"
        >
          <h3 style="color: #fff"><strong>More</strong></h3>
        </mat-card>
      </div>
    </div>
  </section>
</div>
<br />
<br />
<br />
